import { Injectable } from '@angular/core';
import { StorageType } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  getItem<T>(key: string, storageType: StorageType = StorageType.LOCAL): T | null {
    try {
      const storage = this.getStorage(storageType);
      const item = storage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Error obteniendo ${key} del ${storageType}Storage:`, error);
      return null;
    }
  }

  setItem<T>(key: string, value: T, storageType: StorageType = StorageType.LOCAL): void {
    try {
      const storage = this.getStorage(storageType);
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error guardando ${key} en ${storageType}Storage:`, error);
    }
  }

  removeItem(key: string, storageType: StorageType = StorageType.LOCAL): void {
    try {
      const storage = this.getStorage(storageType);
      storage.removeItem(key);
    } catch (error) {
      console.error(`Error eliminando ${key} del ${storageType}Storage:`, error);
    }
  }

  clear(storageType: StorageType = StorageType.LOCAL): void {
    try {
      const storage = this.getStorage(storageType);
      storage.clear();
    } catch (error) {
      console.error(`Error limpiando ${storageType}Storage:`, error);
    }
  }

  private getStorage(storageType: StorageType): Storage {
    return storageType === StorageType.LOCAL ? localStorage : sessionStorage;
  }
}
